import React from 'react';
import { PageContainer } from '@leagueplatform/web-common-components';

export const MasonryPageContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => <PageContainer>{children}</PageContainer>;
